module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion_m.a79b373897d5422cb9a5f4bfbfe35e74.png";